import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, useHistory } from "react-router-dom";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { PermissionsList } from "../../models/Permissions";
import WorkOrderDetails from "../WorkOrderDetails";
import WorkOrderCustomerCard from "../WorkOrderCustomerCard";
import * as api from "../../api";
import { addAPIError, removeAPIError } from "../../utils/translation/helper";
import { saveHazardType, saveHHSRSOption, saveSaverityScore, saveDMCQuestions, storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import { resetHazardAssessmentData, saveHHSRSAssessmentCompleted } from "../../ducks/redux/actions/hazardAssessment";
import { getAssetsById, getAssociatedAssets, getCustomerData, getWorkOrderByIdAPI, getWorkOrderEntity } from "../APIErrorComponent/APIConstantName";
import {
  assetDataStatus, getWorkOrderObject, isActiveTenancy, loadDuplicateRepairPage, resumeDraftRepair, userChosenAdditionalDescription,
  userChosenAdditionalDescriptionCOUNT, userChosenAlertValue, userChosenAssetHierarchy360, userChosenAssetValue,
  userChosenBackValue, userChosenContactDetails, userChosenContactName, userChosenContactPhone, userChosenCovidQuestion,
  userChosenDuplicateEntity, userChosenDuplicateQuestion, userChosenEligibilityErrorCode, userChosenEmergencyQuestion, userChosenHighLevelDescription,
  userChosenIsRecall, userChosenIsReporter, userChosenPropertyAddress, userChosenPropertyId,
  userChosenRelationDetails, userChosenRepairLocation, userChosenRepairLocationId, userChosenResumeRepair, userChosenSOR, userChosenSTATUS,
  userChosenSupplementaryQuestions, userChosenUPRN, userChosenVandalismAdditionalInformation, userChosenVandalismQuestion,
  userChosenVulnerabilityAdditionalInformation, userChosenVulnerabilityQuestion, userResumeData, userResumeDraftDataCache, workOrderData,
  userChosenCurrentValue, userChosenSaveExit, originalWorkOrderData, userChosenAssociatedAssetsList, customerPreferenceData,
  customerAdditionalAlertData, isRepairMediaResume, clearMediaFiles, userChosenUploadedMediaIdentifiers, isCatalystProperty, catalystStatus,
  userChosenIsSurvey, userChosenNotifyAll, repairAddressData, selectedTenancyGroup,
  customersData, dmcCheckSavedAnswer, WorkOrderCaseCreated,
  backToRepairAsset,
  setRepairDiagnosticFinalData,
  dmcInspectionSorCodeValues,
  dmcRepairSorCodeValues,
  woFailureCase,
  saveAppointmentBundle,
  saveEmailCopyRadioValue
} from "../../ducks/redux/actions/userChoices";
import {
  getCustomerId,
  getReferenceNumber,
  repairHistoryData,
  saveAssociatedAssests,
  saveCustomerDetails,
  saveCustomerphoneNumber,
  selectedTenacyType,
  workOrderRepairObject,
  getMaintResp,
  getHeatingHotWaterCase,
  getRepairResp,
  saveAvailabilityResponse,
  getContractorName,
  getDeterminedContractorDetails,
  getContractorPayload,
  saveCustomerId,
  saveSupplimentaryCodes,
  saveCustomerTenacies,
  saveCurrentAssetEligibilityDetails,
  saveSubSessionAssetsEligibilityDetails,
  dmcWorkOrderRepairObject
} from "../../ducks/redux/actions/getAddress";
import WorkOrderChronologySummary from "../WorkOrderChronologySummary";
import { AlertValue, BackValue, WOTypes } from "../../models/shared/Enum";
import CautionAlert from "../CautionAlert";
import {
  CurrentRepair,
  ReportContactDetails,
  RepairStatusField
} from "../../models/Repair/Repair";
import moment from "moment";
import CancelModelRepair from "../Modal/CancelModelRepair";
import CancelModelSurvey from "../Modal/CancelModelSurvey";
import PropertyAlert from "../PropertyAlert";
import { isNullOrUndefined, getDMCSorCodeReference } from "../../utils/formatting";
import { userTypedRepairReasons, updateDashboardForm, assetByIdDataObject, selectedRepairReasonPriorityOverride, resumeRepairReasonPriorityUpdatedToEmergency, priorityCode, selectedRepairReasonDefaultPriority, fetchRepairReasonsSelect, selectedRepairReasonObject } from "../../ducks/redux/actions/dashboardReducer.actions";
import CustomerResponseDetails from "../../models/Customer/CustomerResponseDetails";
import { PremisesType, PremisesTypeId } from "../../models/Customer/Premises";
import AssetCard from "../AssetCard";
import AssetDetails from "../../models/Customer/AssetDetails";
import { isWithinRecallEligibilityPeriod } from "../../utils/formatting";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import CustomerName from "../../models/Customer/CustomerName";
import AdditionalNeedAlert from "../AdditionalNeedAlert";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import NotesCard from "../NotesCard";
import { getPreviousPageName, removeAllDMCData, saveDMCAnswers, woRedirectFromEmailStatus } from "../../ducks/redux/actions/FinancialReferral";
import { getRepairPriority } from "../../utils/formatting";
import { repairPriorityRequest } from "../../models/Repair/RepairReason";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import BackToTopComponent from "../BackToTop";
import useBackToTop from "../BackToTop/useBackToTop";
import { RepairPriorityCode } from "../../models/Repair/CreateRepair";
import Preference from "../../models/Customer/Preference";
import { uuid } from "uuidv4";
import { Helper } from "../../utils/Helper/HelperUtil";
import CustomerCardDetails from "../../models/Customer/CustomerCardDetail";
import { catalystTriageContractorType, EMAContractorType } from "../../models/Repair/Contractor";
import { hasAR1Role } from "../../utils/GetRoles/permission";

interface WorkOrder360ViewProps extends RouteComponentProps<any> {
  Appointment?: string;
  Priority?: string;
  Contractor?: string;
  Description?: string;
  workOrderID?: string;
  status?: string;
  repairReference?: string;
  area?: string;
  fullDescription?: string;
  appointmentDate?: string;
  ContractorsList?: string[];
  siteIdentifier?: string;
  associtaedAsset?: string;
}

const removeHHSRSPrefix = (value: string) =>
  value?.replace(/^HHSRS[-‑]\s*/, "").trim() ?? value;

const WorkOrder360View: React.FC<WorkOrder360ViewProps> = (props) => {
  const dispatch = useDispatch();
  const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
  const [isLoading, setIsLoading] = useState(false);
  let [draftRepair, setDraftRepair] = useState<any>();
  const { t } = useTranslation();
  const { backToTop, width } = useBackToTop();
  const [isWorkCard, setIsWorkCard] = useState(false);
  const [isCustomerCard, setIsCustomerCard] = useState(false);
  const [isAssetCard, setIsAssetCard] = useState(false);
  const [dropDown, setDropDown] = useState("none");
  const [assetUprn, setAssetUprn] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [isPropertyBanner, setPropertyBanner] = useState(false);
  const [isCancelButton, setIsCancelButton] = useState(false);
  const [isAppointment, setIsAppointment] = useState(false);
  const [isAppointmentRole, setIsAppointmentRole] = useState(false);
  const [errorCode, setErrorCode] = useState("");
  const [area, setArea] = useState("");
  const [contractor, setContractor] = useState("");
  const [propertyCheck, setPropertyCheck] = useState(false);
  const [isCautionBanner, setIsCaution] = useState(false);
  const [customerDetails, setCustomerDetails] =
    useState<CustomerResponseDetails>();
  const [assetValue, setAssetValue] = useState("");
  const [isWorkOrderLoaded, setIsWorkOrderLoaded] = useState(false);
  const [customerIdentifier, setCustomerIdentifier] = useState("");
  const [isCreateSurvey, setIsCreateSurvey] = useState(false);
  let assetRegionValue: string = "";
  const [status, setStatus] = useState("");
  const [jobNumber, setJobNumber] = useState("");
  const [identifiedCatalystProperty, setIsCataLyst] = useState(false);
  const [catalystBannerMessageA, setCatalystBannerMessageA] = useState("");
  const [catalystBannerMessageB, setCatalystBannerMessageB] = useState("");
  const [isRepairFullyCreated, setIsRepairFullyCreated] = useState(false);
  const [woSerialNumber, setWoSerialNumber] = useState("");
  const [woSequenceNumber, setWoSequenceNumber] = useState("");
  const [isUnderReviewTriage, setIsUnderReviewTriage] = useState(false);
  const [isSelectAppointmentChosen, setIsSelectAppointmentChosen] =
    useState(false);
  const [woHadDemobilizedContractorSite, setWOHadDemobilizedContractorSite] =
    useState(false);
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  let [reviewTriageRepairPermission, setReviewTriageRepairPermission] = useState(
    getPermissionsData?.indexOf(
      PermissionsList.workorder_review_triage_repair
    ) >= 0
  );
  let [noTriagePermission] = useState(
    getPermissionsData?.indexOf(
      PermissionsList.workorder_no_triage_forheatingandhotwaterrepairs
    ) >= 0
  );
  let [duplicateOverridePermissions] = useState(
    getPermissionsData?.indexOf(
      PermissionsList.workorder_override_duplicate_repairs
    ) >= 0
  );
  let [choosePriorityPermission] = useState(
    getPermissionsData?.indexOf(
      PermissionsList.workorder_choose_priority_of_repair
    ) >= 0
  );
  const additionalNeedsAlertsBasic = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.additional_needs_alerts_basic) !== -1;
  const additionalNeedsAlertsRestricted = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.additional_needs_alerts_restricted) !== -1;
  const history = useHistory();
  const OnHoldContractor = "CONTRACTORSITE_ON_HOLD";
  enum LandlordAppConfigValues {
    IsCheckForLandlord = "IsCheckForLandlordP360",
    LandlordValues = "LandlordValues",
    CatalystRepairDisabledAreas = "CatalystRepairDisabledAreasP360",
    CatalystRegistrationAreas = "CatalystRegistrationAreas",
  }

  const workOrders = useSelector(
    (state: any) => state?.userChoicesReducer?.workOrderData
  );

  const isContractorIntegerated = useSelector(
    (state: any) => state?.addresses?.getIntegeratedContractor
  );
  const finishJourney = useSelector(
    (state: any) => state?.financialReferralReducer?.isJourneyFinish
  );

  const dmCauseCheckSkipSorCodesValue = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const userChosenContactNameVal = useSelector(
    (state: any) => state.userChoicesReducer.userChosenContactName
  );
  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );
  const demobilizedContractorList = useSelector(
    (state: any) => state?.userChoicesReducer?.demobilizedContractorSites
  );

  const recallEligibilityPeriodInMonths = useSelector(
    (state: any) => state?.userChoicesReducer?.recallEligibilityPeriodInMonths
  );

  const dmcInspectionSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues
  );
  const dmcRepairSorCodes = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairSorCodeValues
  );

  let [customerID] = useState("");

  const [isRepairEnabled, setIsRepairEnabled] = useState(false);

  let customerResponse: any;
  let errorData: any = [];

  const [isRecallEligible, setIsRecallEligible] = useState(false);

  const [isAssetEligibleForRepair, setIsAssetEligibleForRepair] = useState(false);

  let subSessionAssetsEligibilityDetailsRedux = useSelector(
    (state: any) => state?.addresses?.subSessionAssetsEligibilityDetails
  );
  let tenancyGroup: string = "";

  const prepareAppointmentBundleForCurrentWO = async (isDMInspectionFromMultiWOSystem: boolean) => {

    const woAppointmentReponseBundle = {
      id: workOrders?.identifiers?.worksOrderIdentifier,
      contractorCode: workOrders?.contractor?.code,
      contractorName: workOrders?.contractor?.name,
      jobNo: workOrders?.identifiers?.jobNumber,
      operationKey: uuid(),
      isAppointable: true,
      calendar: null
    }

    const bundle = Helper.buildAppointmentBundle({
      original: !isDMInspectionFromMultiWOSystem ? woAppointmentReponseBundle : null,
      dmc: isDMInspectionFromMultiWOSystem ? woAppointmentReponseBundle : null,
    });

    dispatch(saveAppointmentBundle(bundle));
    props.history.push("/AppointmentScheduler");
    return;
  };
  const checkPrimiseEligilibility = async (
    premisesId: any,
    tenancyGroup: any,
    assetType: any,
    associatedAssetsData: any
  ) => {
    const responsePremisesEligibilityResp = await api.postPremisesEligibility(
      premisesId,
      tenancyGroup
    );
    if (responsePremisesEligibilityResp?.length > 0) {

      const assetTypeId = Number.parseInt(PremisesTypeId[assetType]);
      const hasParentPresent = associatedAssetsData?.filter((x: any) => {
        const associatedTypeId = Number.parseInt(PremisesTypeId[x.assetType]);
        return associatedTypeId < assetTypeId;
      });
      const responsePremisesEligibility = responsePremisesEligibilityResp[0];
      const hasParent = hasParentPresent?.length > 0 ? true : false;
      const matchBR12BR13 = (responsePremisesEligibility?.errorCode === "E4" && assetType !== "Property") || responsePremisesEligibility?.errorCode === "E24";
      let assetEligibilityForRaiseRepair = {
        assetId: premisesId,
        assetEligibilityResponse: responsePremisesEligibility,

        // We want to stop scenario when asset matches BR 12 & BR13 and is capable of skipping Repair Asset page
        isEligibleToRaiseARepair: !responsePremisesEligibility?.isEligible && !hasParent && matchBR12BR13 ? false : true
      }

      // We want to stop scenario when asset matches BR 12 & BR13 and is capable of skipping Repair Asset page

      let assetEligibilityDetailsCache = subSessionAssetsEligibilityDetailsRedux ?? [];
      assetEligibilityDetailsCache.push(assetEligibilityForRaiseRepair);
      dispatch(saveSubSessionAssetsEligibilityDetails(assetEligibilityDetailsCache));
      setIsAssetEligibleForRepair(assetEligibilityForRaiseRepair.isEligibleToRaiseARepair);
      dispatch(saveCurrentAssetEligibilityDetails(assetEligibilityForRaiseRepair));
    }
  }

  let [workIdFromUrl, setWorkIdFromUrl] = useState("");
  const alertApiFunction = (assetId: string) => {
    (async () => {
      try {
        const alertApiResponse = await api.getAlert(assetId);
        let finalAlertData: any[] = [];
        if (
          alertApiResponse !== null &&
          alertApiResponse !== "" &&
          alertApiResponse !== undefined
        ) {
          alertApiResponse.map((alertData: any) => {
            if (alertData?.type === AlertValue.Rapid) {
              finalAlertData.push(alertData);
              setPropertyCheck(true);
              dispatch(userChosenAlertValue(finalAlertData));
            }
          });
        } else {
          setPropertyCheck(false);
        }
      } catch (e) {
        console.error(e);
      }
    })();
  };
  const clear = () => {
    // removing all dmc answers when user changes 
    dispatch(WorkOrderCaseCreated(false));
    dispatch(removeAllDMCData(null));
    dispatch(catalystStatus(""));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(getReferenceNumber(null));
    dispatch(userTypedRepairReasons(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenDuplicateQuestion(""));
    dispatch(userChosenDuplicateEntity(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenVulnerabilityQuestion(""));
    dispatch(userChosenVulnerabilityAdditionalInformation(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenSOR(""));
    dispatch(getRepairResp(""));
    dispatch(getHeatingHotWaterCase(""));
    dispatch(getMaintResp(""));
    dispatch(getDeterminedContractorDetails(""));
    dispatch(getContractorName(""));
    dispatch(getContractorPayload(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(selectedTenacyType(""));
    dispatch(workOrderRepairObject(null));
    dispatch(userChosenIsReporter(false));
    dispatch(loadDuplicateRepairPage(false));
    dispatch(userChosenResumeRepair(false));
    dispatch(userChosenSaveExit(false));
    dispatch(customerPreferenceData({}));
    dispatch(customerAdditionalAlertData({}));
    dispatch(clearMediaFiles([]));
    dispatch(userChosenUploadedMediaIdentifiers([]));
    dispatch(userChosenNotifyAll(null));
    dispatch(saveAvailabilityResponse(null));
    dispatch(repairHistoryData(null));
    dispatch(assetByIdDataObject(null));
    dispatch(selectedTenancyGroup(""));
    dispatch(userChosenIsSurvey(false));
    dispatch(saveSupplimentaryCodes(""));
    dispatch(saveCustomerDetails(null));
    dispatch(userChosenAssetValue(null));
    dispatch(userChosenAssetHierarchy360(null));
    dispatch(saveAssociatedAssests(null));
    dispatch(userChosenBackValue(null));
    dispatch(userChosenCurrentValue(null));
    dispatch(priorityCode(""));
    dispatch(backToRepairAsset(false));
    dispatch(repairAddressData([]));
    dispatch(setRepairDiagnosticFinalData(null));
    dispatch(saveCurrentAssetEligibilityDetails(null));
    dispatch(woFailureCase(""));
    dispatch(saveAppointmentBundle(null));
    dispatch(dmcWorkOrderRepairObject(null));
    dispatch(userChosenAssociatedAssetsList(null));
    dispatch(saveAssociatedAssests(null));
    dispatch(originalWorkOrderData(null));
    dispatch(isActiveTenancy(false));
    dispatch(userChosenIsRecall(false));
    dispatch(userChosenBackValue(BackValue.WorkOrder360View));
    dispatch(userChosenCurrentValue(BackValue.WorkOrder360View));
    dispatch(userChosenAssetHierarchy360(BackValue.WorkOrder360View));
  };
  const isRaiseRepairEnabled = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.create_repair_standard) !== -1;
  const getWorkOrderById = async () => {
    try {
      const response = await api.getWorkOrder(workIdFromUrl);
      errorData = removeAPIError(getWorkOrderByIdAPI, errors);
      setErrorFlag(false);
      return response;
    } catch (error: any) {
      errorData = addAPIError(getWorkOrderByIdAPI, errors);
      setIsWorkCard(true)
      setErrorFlag(true)
      setIsWorkOrderLoaded(true);
    }
    dispatch(storeAPIErrors(errorData))
  };
  useEffect(() => {
    (async () => {
      try {
        const dmcInspectionSorCodess = await api.GetAppConfigToggleValue("dmcInspectionSorCodes");
        const dmcRepairSorCodess = await api.GetAppConfigToggleValue("dmcRepairSorCodes");
        dispatch(dmcInspectionSorCodeValues(dmcInspectionSorCodess?.value));
        dispatch(dmcRepairSorCodeValues(dmcRepairSorCodess?.value));
      } catch (e: any) {
        console.error(e);
      }
    })()
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);

    if (getPermissionsData?.length > 0) {
      const viewWorkOrder360View = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_work_order_360_view) !== -1;
      let wo360ViewHref = window.location.href;
      const regexForWOGuidFromUrl = new RegExp(
        /WorkOrder360View\/([a-z0-9-']*)/g,
        "i"
      ),
        workOrderIdFromUrl = regexForWOGuidFromUrl.exec(wo360ViewHref),
        woIdFromUrl = workOrderIdFromUrl ? workOrderIdFromUrl[1] : "";
      setWorkIdFromUrl(woIdFromUrl);
      workIdFromUrl = woIdFromUrl;

      let isRedirectRequire = window.location.search;
      if (isNullOrUndefined(woIdFromUrl) || !viewWorkOrder360View) {
        // Redirect to Landig page if WO Guid not present in URL
        props.history.push("/LandingView");
      }

      (async () => {
        clear();
        try {
          const workOrderResponse = await api.getWorkOrderEntity(woIdFromUrl);

          // Setting isDraft true while resuming so that we can attempt WO creation for WO which failed job creation in ERGO
          if (workOrderResponse) {
            if (workOrderResponse?.isPendingAssessment) {
              await fetchDMCQuestionsData();
            }
            dispatch(workOrderRepairObject(workOrderResponse));
            dispatch(storeAPIErrors(removeAPIError(getWorkOrderEntity, errors)));
            workOrderResponse.isDraft = isNullOrUndefined(
              workOrderResponse?.jobNo
            );
            setWOHadDemobilizedContractorSite(
              demobilizedContractorList?.some(
                (x: string) =>
                  x.toLowerCase() === workOrderResponse?.contractor?.toLowerCase()
              )
            );
            if (workOrderResponse?.description === "Inspect Damp and Mould" || workOrderResponse?.repairReason === "Inspect Damp and Mould") {
              workOrderResponse.description = "Investigate damp or mould";
              workOrderResponse.repairReason = "Investigate damp or mould";
            }
            setDraftRepair(workOrderResponse);
            alertApiFunction(workOrderResponse?.assetIdentifier);
            if (!isNullOrUndefined(workOrderResponse?.assetIdentifier)) {
              let assetIdentifier = workOrderResponse?.assetIdentifier;
              await callGetAssetByIdApi(assetIdentifier);
            }

            if (workOrderResponse.jobNo) {
              setIsRepairFullyCreated(true);
              const [serialNumber, sequenceNumber] =
                workOrderResponse.jobNo.split("/");
              setWoSerialNumber(serialNumber);
              setWoSequenceNumber(sequenceNumber);
            }
            await getCancelRepairEligibility(
              workOrderResponse,
              workOrders?.asset?.type?.assetTypeName
            );
            await getIsRecallEligibility(workOrderResponse);

            if (
              workOrderResponse?.status === RepairStatusField.CatalystEMATriage
            ) {
              setJobNumber(RepairStatusField.CatalystEMAStatus);
              setStatus(RepairStatusField.CatalystEMAStatus);
              dispatch(catalystStatus(RepairStatusField.CatalystEMAStatus));
            } else if (
              workOrderResponse?.status ===
              RepairStatusField.CatalystDefectTriage ||
              workOrderResponse?.status === RepairStatusField.CatalystTier2Triage
            ) {
              setJobNumber(workOrderResponse?.status);
              setStatus(workOrderResponse?.status);
              dispatch(catalystStatus(workOrderResponse?.status));
            } else {
              dispatch(catalystStatus(workOrderResponse?.status));
              setStatus(workOrderResponse?.status);
            }

            if (isRedirectRequire === '?isPendingAssessment=true' && hasAR1Role(getPermissionsData)
              && workOrderResponse?.isPendingAssessment) {
              props.history.push('/VulnerabilityAssessment');
            }

            // Redirecting triage email work order when api response comes
            let routeChange: boolean = ((isRedirectRequire === "?reviewWorkOrder=true") || (isRedirectRequire === "?resumeWorkOrder=true"));
            if (routeChange) {
              setIsLoading(true);
              reviewTriageRepairPermission =
                getPermissionsData?.indexOf(
                  PermissionsList.workorder_review_triage_repair
                ) >= 0;
              noTriagePermission =
                getPermissionsData?.indexOf(
                  PermissionsList.workorder_no_triage_forheatingandhotwaterrepairs
                ) >= 0;
              duplicateOverridePermissions =
                getPermissionsData?.indexOf(
                  PermissionsList.workorder_override_duplicate_repairs
                ) >= 0;
              choosePriorityPermission =
                getPermissionsData?.indexOf(
                  PermissionsList.workorder_choose_priority_of_repair
                ) >= 0;
              dispatch(userChosenResumeRepair(true));
              dispatch(woRedirectFromEmailStatus(true));
              dispatch(userChosenSOR(workOrderResponse?.sorCode));
              //Shifted redirect under below function
              resumeRepairHandler(workOrderResponse, isRedirectRequire);
            }
            else {
              setIsLoading(false)
            }
          }
        } catch (e) {
          console.error(e);
          setIsLoading(false);
          dispatch(storeAPIErrors(addAPIError(getWorkOrderEntity, errors)));
          setErrorFlag(true);
        }
      })();

      const showCustomer = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
        PermissionsList.view_customer_profile_card
      ),
        showWork = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.view_work_order_details_card
        ),
        showAsset = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.view_asset_details_card
        ),
        showProperty = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.view_workorder360_property_alerts_banner
        ),
        showisAppointmentRole = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.view_digital_journey_appoint_a_repair
        ),
        showCaution = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.view_workorder360_caution_alerts_banner
        );

      setIsCustomerCard(showCustomer !== -1);
      setIsWorkCard(showWork !== -1);
      setIsAssetCard(showAsset !== -1);
      setPropertyBanner(showProperty !== -1);
      setIsAppointmentRole(showisAppointmentRole !== -1);
      setIsCaution(showCaution !== -1);

      (async () => {
        try {
          setIsWorkOrderLoaded(false);
          const workOrderDataResponse = await getWorkOrderById();
          const isUnderReviewTriage =
            workOrderDataResponse?.statuses?.isSubmitted &&
            (workOrderDataResponse?.statuses?.isPotentialDuplicate ||
              workOrderDataResponse?.customer?.vulnerability?.isVulnerable ||
              workOrderDataResponse?.job?.sorCode === "NA");
          setIsUnderReviewTriage(isUnderReviewTriage ?? false);
          setReviewTriageRepairPermission(getPermissionsData?.indexOf(PermissionsList.workorder_review_triage_repair) >= 0);
          if (
            workOrderDataResponse &&
            workOrderDataResponse !== undefined &&
            workOrderDataResponse !== null
          ) {
            dispatch(workOrderData(workOrderDataResponse));
            dispatch(originalWorkOrderData(workOrderDataResponse));
            dispatch(
              updateDashboardForm({
                assetId:
                  workOrderDataResponse?.identifiers?.asset?.assetIdentifier,
              })
            );
            setIsWorkOrderLoaded(true);
            dispatch(getWorkOrderObject(workOrderDataResponse));
          }
          setIsLoading(false);
        } catch (e) {
          setIsLoading(false);
          console.error(e);
        }
        const createSurvey = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
          PermissionsList.create_p360_surveying1
        );
        setIsCreateSurvey(createSurvey !== -1);
      })();
    }
  }, [getPermissionsData]);

  const fetchDMCQuestionsData = async () => {
    try {
      const responseData = await api.getQuestionnaireMasterData();
      const keyValuePairs = responseData[0]?.namespace?.keyValues;
      for (const data of Object.entries(keyValuePairs)) {
        const [, value] = data;
        if (value && (value as any).id === '46') {
          dispatch(saveDMCQuestions(value));
        }
      }
    } catch (e: any) {
      console.error("Error occured!", e);
      props.history.push("/GenericError");
      setIsLoading(false);
    }
  }

  const getIsRecallEligibility = async (workOrderResponse: CurrentRepair) => {
    const showisRecallRole = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(
      PermissionsList.view_digital_journey_recall_a_repair
    );
    const eligibleStatuses = ["closed", "completed"];
    const isStatusEligibleForRecall =
      workOrderResponse &&
      workOrderResponse.status &&
      eligibleStatuses.indexOf(workOrderResponse.status.toLowerCase()) > -1;
    const isMPT =
      workOrderResponse.contractor &&
      workOrderResponse.contractor !== "" &&
      workOrderResponse.contractor.toLowerCase()?.indexOf("mpt") > -1;

    const eligibleWorkProgramme = ["RESP", "GASRESP", "MERESP"];
    const checkRecall: boolean =
      eligibleWorkProgramme?.indexOf(
        workOrderResponse.workProgramme?.toUpperCase()
      ) > -1;

    if (
      showisRecallRole &&
      isStatusEligibleForRecall &&
      ([RepairPriorityCode.V14,
      RepairPriorityCode.NextAvailable] as string[]).includes(workOrderResponse.priorityCode)
      &&
      checkRecall &&
      !isMPT &&
      isWithinRecallEligibilityPeriod(workOrderResponse.completedDate, recallEligibilityPeriodInMonths)
    ) {
      setIsRecallEligible(true);
    } else {
      setIsRecallEligible(false);
    }
  };
  const fetchAssetData = async (id: string) => {
    try {
      const assetData = await api.getAssetsByid(id);
      dispatch(storeAPIErrors(removeAPIError(getAssetsById, errors)));
      return assetData;
    } catch (e) {
      dispatch(storeAPIErrors(addAPIError(getAssetsById, errors)));
      return null;
    }
  };
  const callGetAssetByIdApi = async (id: string) => {
    try {
      let associtaedAssets: AssetDetails[] = [];
      let associtaedAssetsList: AssetDetails[] = [];
      let custResponse: CustomerResponseDetails;
      const assetResponse = await fetchAssetData(id);
      let custHasActiveTenency = false;
      dispatch(assetByIdDataObject(assetResponse));
      let associatedAssetsResponse;
      try {
        associatedAssetsResponse = await api.getAssociatedAssets(id);
        dispatch(storeAPIErrors(removeAPIError(getAssociatedAssets, errors)));
      } catch (error) {
        dispatch(storeAPIErrors(addAPIError(getAssociatedAssets, errors)));
        console.error("Failed to fetch associated assets:", error);
        return;
      }
      let addressList = [];
      addressList.push(associatedAssetsResponse);
      dispatch(repairAddressData(addressList));
      associtaedAssets.push(associatedAssetsResponse);
      const queryParams = {
        searchText: "",
        skip: 0,
        customerType: "Active Customer",
        orderBy: "",
        tenancyType: "",
        uprn: assetResponse?.uprn,
      };
      assetRegionValue = assetResponse?.region ?? "";
      if (workOrders.identifiers?.customerIdentifier) {
        const responseTenancyGroup = await api.getTenanciesGroup(
          workOrders.identifiers?.customerIdentifier,
          assetResponse?.id ?? ""
        );
        tenancyGroup = responseTenancyGroup?.[0]?.tenancyGroup || "";
      }
      const currentAssetCachedEligibilityOutcome = subSessionAssetsEligibilityDetailsRedux?.find((assetEligDetailEle: any) => assetEligDetailEle.assetId === assetResponse?.id);
      if (isNullOrUndefined(currentAssetCachedEligibilityOutcome)) {
        await checkPrimiseEligilibility(
          assetResponse?.id,
          tenancyGroup,
          assetResponse?.assetType,
          associatedAssetsResponse
        );
      } else {
        setIsAssetEligibleForRepair(currentAssetCachedEligibilityOutcome.isEligibleToRaiseARepair);
        dispatch(saveCurrentAssetEligibilityDetails(currentAssetCachedEligibilityOutcome));
      }
      let customerSearchApi;
      try {
        customerSearchApi = await api.getCustomerData(queryParams);
        dispatch(storeAPIErrors(removeAPIError(getCustomerData, errors)));
      } catch (error) {
        dispatch(storeAPIErrors(addAPIError(getCustomerData, errors)));
        console.error("Failed to fetch customer data:", error);
        return;
      }
      const customerCallResponse = customerSearchApi?.models;
      dispatch(getCustomerId(customerCallResponse[0]?.id));
      customerID = customerCallResponse[0]?.id;
      dispatch(saveCustomerId(customerCallResponse[0]?.id))
      let customerPreferenceDataObj: Preference[] = [];
      if (
        customerCallResponse?.length !== 0 &&
        customerCallResponse?.[0]?.id !== undefined &&
        customerCallResponse?.[0]?.id !== ""
      ) {
        // setIsWorkOrderCustomerCard(true);
        customerCallResponse.forEach(async (element: CustomerCardDetails) => {
          if (element.id !== "" && element.id !== undefined && element.id !== null) {
            try {
              customerResponse = await api.getCustomer(element.id);
              if (customerCallResponse[0]?.id === element.id) {
                custResponse = customerResponse;
                const tenancyActive = customerResponse?.tenanciesSummaries
                dispatch(saveCustomerTenacies(tenancyActive));
                setCustomerDetails(custResponse);
                dispatch(saveCustomerDetails(custResponse));
                if (tenancyActive?.length > 0) {
                  custHasActiveTenency = true;
                  dispatch(isActiveTenancy(true));
                  dispatch(userChosenAssociatedAssetsList(tenancyActive));
                } else {
                  custHasActiveTenency = false;
                  dispatch(isActiveTenancy(false));
                }
              }
              if (customerResponse?.preferences?.length > 0) {
                customerPreferenceDataObj = customerPreferenceDataObj.concat(customerResponse?.preferences);
                let customerAdditionalAlertDataObj: Preference[] = [];
                let customerPreferenceAlertObj: Preference[] = [];
                customerAdditionalAlertDataObj = customerPreferenceDataObj?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
                customerPreferenceAlertObj = customerPreferenceDataObj?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type !== 'additionalNeeds');
                if (customerPreferenceAlertObj?.length > 0) {
                  dispatch(customerPreferenceData(customerPreferenceAlertObj))
                }
                if (customerAdditionalAlertDataObj.length > 0) {
                  dispatch(customerAdditionalAlertData(customerAdditionalAlertDataObj))
                }
              }
            }
            catch (e) {
              console.error(e);
            }
          }
        })

        if (
          workOrders.identifiers?.customerIdentifier !== null &&
          workOrders.identifiers?.customerIdentifier !== undefined &&
          workOrders.identifiers?.customerIdentifier !== ""
        ) {
          setCustomerIdentifier(workOrders.identifiers?.customerIdentifier);
        } else {
          setCustomerIdentifier(customerCallResponse[0]?.id);
        }
        if (customerResponse?.addresses?.telecomsAddresses) {
          dispatch(
            saveCustomerphoneNumber(
              customerResponse?.addresses?.telecomsAddresses
            )
          );
        } else {
          dispatch(saveCustomerphoneNumber(null));
        }
        dispatch(selectedTenacyType(workOrders?.asset?.type?.assetTypeName));
      }

      const appCatalystRegistrationAreasValues =
        await api.GetAppConfigToggleValue(
          LandlordAppConfigValues.CatalystRegistrationAreas
        );
      const appCatalystRepairDisabledAreasValues =
        await api.GetAppConfigToggleValue(
          LandlordAppConfigValues.CatalystRepairDisabledAreas
        );

      const isCatalystDisabledArea =
        !isUndefinedNullOrEmpty(assetRegionValue) &&
        appCatalystRepairDisabledAreasValues.value
          .toLowerCase()
          .includes(assetRegionValue.toLowerCase());
      let isCatalystRegistrationArea =
        !isUndefinedNullOrEmpty(assetRegionValue) &&
        appCatalystRegistrationAreasValues.value
          .toLowerCase()
          .includes(assetRegionValue.toLowerCase());

      const associatesdata = await api.GetPropertyAssociates(assetResponse?.id ?? "");
      let currentLandlord =
        associatesdata?.associates?.landLord?.organisation?.name;
      let previousLandLord =
        associatesdata?.associates?.previousLandLord?.organisation?.name;
      const appConfigLandlordValues = await api.GetAppConfigToggleValue(
        LandlordAppConfigValues.LandlordValues
      );

      const catalystLandlord =
        (currentLandlord?.length > 0 &&
          appConfigLandlordValues?.value.includes(currentLandlord)) ||
        (previousLandLord?.length > 0 &&
          appConfigLandlordValues?.value.includes(previousLandLord));

      const identifiedCatalystProperty =
        isCatalystRegistrationArea || catalystLandlord;

      setIsCataLyst(identifiedCatalystProperty);
      dispatch(isCatalystProperty(identifiedCatalystProperty));

      switch (assetRegionValue) {
        case "HUB1-REP":
          setCatalystBannerMessageA(t("CP126EnabledHub1a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case "HUB2-REP":
          setCatalystBannerMessageA(t("CP126EnabledHub2a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case "HUB3-REP":
          setCatalystBannerMessageA(t("CP126EnabledHub3a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        case "HUB4-REP":
          setCatalystBannerMessageA(t("CP126EnabledHub4a"));
          setCatalystBannerMessageB(t("CP126EnabledHubb"));
          break;
        default:
          // For Non Catalyst Properties, isIdentifiedCatalystProperty will be false, message wont be visible
          // For Catalyst properties where landlord is catalyst but fron a diff asset region
          setCatalystBannerMessageA(t("CP125a"));
          setCatalystBannerMessageB(t("CP125b"));
          break;
      }

      if (isCatalystDisabledArea) {
        setCatalystBannerMessageA(t("CP125a"));
        setCatalystBannerMessageB(t("CP125b"));
      }
      if (
        assetResponse?.addresses?.postalAddresses[0].formattedAddress != null
      ) {
        dispatch(
          userChosenPropertyAddress(
            assetResponse?.addresses?.postalAddresses[0].formattedAddress
          )
        );
      }
      let associatedAssetData: any;
      let assetType = assetResponse?.assetType;
      setAssetValue(assetType ?? "");
      setIsRepairEnabled(assetType === PremisesType.Property ? custHasActiveTenency : true);
      dispatch(userChosenAssetValue(assetType));
      if (assetType === PremisesType.Estate) {
        associatedAssetData = associtaedAssets[0].filter(
          (x) => x.assetType === PremisesType.Estate
        );
        associtaedAssetsList.push(associatedAssetData);
      }
      if (assetType === PremisesType.Block) {
        associatedAssetData = associtaedAssets[0].filter(
          (x) =>
            x.assetType === PremisesType.Block ||
            x.assetType === PremisesType.Estate
        );
        associtaedAssetsList.push(associatedAssetData);
      }
      if (assetType === PremisesType.DividedBlock) {
        associatedAssetData = associtaedAssets[0].filter(
          (x) =>
            x.assetType === PremisesType.Block ||
            x.assetType === PremisesType.Estate ||
            x.assetType === PremisesType.DividedBlock
        );
        associtaedAssetsList.push(associatedAssetData);
      }
      if (assetType === PremisesType.Property) {
        associatedAssetData = associtaedAssets[0];
        associtaedAssetsList.push(associatedAssetData);
      }
      dispatch(saveAssociatedAssests(associtaedAssetsList));
      setAssetUprn(assetResponse?.uprn ?? "");

      dispatch(assetDataStatus(assetResponse?.assetStatus));
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  };
  const backButtonHandler = () => {
    if (finishJourney) {
      props.history.push("/LandingView");
    } else {
      history.goBack();
    }
  };
  const dropDownFunction = () => {
    if (dropDown === "none") setDropDown("block");
    else setDropDown("none");
  };
  const callPageHandler = () => {
    //dispatch(getCustomerId(workOrders?.identifiers?.customerIdentifier));

    if (!isP360Maintainence) {
      dispatch(workOrderRepairObject(null));
      dispatch(resumeDraftRepair(false)); 
      dispatch(woRedirectFromEmailStatus(false));
      dispatch(selectedTenacyType(workOrders?.asset?.type?.assetTypeName));
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      if (isNullOrUndefined(customerDetails?.addresses?.telecomsAddresses)) {
        dispatch(saveCustomerphoneNumber(null));
      } else {
        dispatch(
          saveCustomerphoneNumber(customerDetails?.addresses?.telecomsAddresses)
        );
      }
      props.history.push("/RepairAsset", { previousPathname: window.location.pathname });
    }
  };

  const selectAppointmentHandler = async () => {
    if (!isP360Maintainence) {
      setIsSelectAppointmentChosen(true);
      const historyData = CreateHistoryData();
      dispatch(repairHistoryData(historyData));

      const isDMInspectionFromMultiWOSystem = getDMCSorCodeReference(dmCauseCheckSkipSorCodesValue, workOrders?.job?.sorCode) && workOrders?.identifiers?.associatedWorkOrders?.length > 0

      if (isDMInspectionFromMultiWOSystem) {
        dispatch(dmcWorkOrderRepairObject(draftRepair));
        dispatch(workOrderRepairObject(null));
      }

      try {
        setIsLoading(true);
        await prepareAppointmentBundleForCurrentWO(isDMInspectionFromMultiWOSystem);
      } catch (e) {
        setIsLoading(false);
        console.error("prepare Appointment Bundle For WO failed", e);
        props.history.push("/RepairFinalDetails");
      }
    }
  };

  const CreateHistoryData = () => {
    return {
      //Used
      repairHistoryContractor: draftRepair?.contractorName,
      repairHistoryWorkOrderID: draftRepair?.id,
      repairHistoryJobNumber: draftRepair?.jobNo,
      //Not In use
      repairHistoryPriority: draftRepair?.priority, //Next Available, emergency
      repairHistoryDescription: draftRepair?.repairReason,
      repairHistoryStatus: draftRepair?.status,
      repairHistoryArea: draftRepair?.area,
      repairHistoryFullDescription: draftRepair?.description,
    };
  };

  const recallRepairHandler = async () => {
    try {
      if (draftRepair) {
        dispatch(userChosenIsRecall(true));
        const workOrderRepair = new CurrentRepair();
        // Remove 'HHSRS-'from the start of the repairReason,additionalInformation and description
        const isHHSRSHazard = draftRepair?.isHHSRSHazard
        if (isHHSRSHazard) {
          workOrderRepair.repairReason = removeHHSRSPrefix(draftRepair.repairReason);
          workOrderRepair.additionalInformation = removeHHSRSPrefix(draftRepair.description);
          workOrderRepair.description = removeHHSRSPrefix(draftRepair.repairReason);
        } else {
          workOrderRepair.repairReason = draftRepair?.repairReason;
          workOrderRepair.additionalInformation = draftRepair?.description;
          workOrderRepair.description = draftRepair?.repairReason;
        }
        workOrderRepair.premisesId = draftRepair.assetIdentifier;
        workOrderRepair.premisesTypeId = draftRepair.premisesTypeId;
        workOrderRepair.customerIdentifier = draftRepair.customerIdentifier;
        workOrderRepair.isEmergency = draftRepair.isEmergency;
        workOrderRepair.premisesUniqueReference =
          draftRepair.premisesUniqueReference;
        workOrderRepair.premisesAddress = draftRepair.premisesAddress;
        workOrderRepair.sorCode = draftRepair.sorCode;
        workOrderRepair.contractor = draftRepair.contractor;
        workOrderRepair.customerName = new CustomerName({
          title: draftRepair?.customerName?.title,
          givenName: draftRepair?.customerName?.givenName,
          surname: draftRepair?.customerName?.surname,
        });
        workOrderRepair.reportingMethodId = draftRepair.reportingMethodId;
        workOrderRepair.reportingMethod = draftRepair.reportingMethod;

        workOrderRepair.notifyAll = false;
        workOrderRepair.eTag = draftRepair?.eTag;
        workOrderRepair.eligibilityOutcomes = [];
        workOrderRepair.assetIdentifier = draftRepair.assetIdentifier;
        workOrderRepair.repairLocationId = draftRepair.repairLocationId;
        workOrderRepair.repairCause = "General Wear and Tear";

        workOrderRepair.repairCauseId = draftRepair.repairCauseId;

        workOrderRepair.isRecall = true;
        workOrderRepair.isDraft = true;
        workOrderRepair.id = draftRepair.id;
        const draftRepairPriorityCode = draftRepair.priorityCode || '';
        workOrderRepair.priority = draftRepairPriorityCode;

        const _worksOrderRequest = new WorksOrderRequest(workOrderRepair);
        const woRequestParameters =
          _worksOrderRequest.createWorkOrderParameter(workOrderRepair);
        let apiResponse: any;
        try {
          apiResponse = await api.createWorkOrderRepair({
            ...woRequestParameters,
          });
        } catch (e) {
          console.error(e);
        }

        if (apiResponse?.location.length > 0) {
          const workorderLocation = apiResponse?.location.split("/");
          workOrders.id = workorderLocation[4];
          workOrders.worksOrderIdentifier = workorderLocation[4];

          draftRepair.id = workorderLocation[4];
          draftRepair.worksOrderIdentifier = workorderLocation[4];
          draftRepair.isRecall = true;
          draftRepair.isDraft = true;
          const reportContactDetails = new ReportContactDetails();
          reportContactDetails.contactNumber =
            workOrders?.reporter?.addresses?.telecomsAddresses?.[0]?.number;

          reportContactDetails.reporterToBeContacted = false;

          const contactPersonName = new CustomerName({
            title: null,
            givenName: draftRepair?.customerName?.givenName,
            surname: null,
          });

          reportContactDetails.name = contactPersonName;
          draftRepair.reporterContactDetails = reportContactDetails;

          draftRepair.description = isHHSRSHazard ? removeHHSRSPrefix(draftRepair.repairReason) : draftRepair.repairReason;
          draftRepair.repairReason = isHHSRSHazard ? removeHHSRSPrefix(draftRepair.repairReason) : draftRepair.repairReason;
          draftRepair.reportedBy = "Customer";
          draftRepair.reportedById = 1;
          draftRepair.associatedWorkOrdersIdentifier = '';
          draftRepair.associatedWorkOrdersType = '';
          draftRepair.associatedWorkOrdersJobNumber = '';
          draftRepair.assessmentInformation = null;
          draftRepair.isCausingDampAndMould = null;
          draftRepair.jobNo = ""

          //---

          const _worksOrderRequest = new WorksOrderRequest(draftRepair);
          const woRequestParameters =
            _worksOrderRequest.updateWorkOrderParameter(draftRepair);

          woRequestParameters.priority = draftRepairPriorityCode;

          woRequestParameters.originalWorkOrderIdentifier =
            draftRepair.originalWorkOrderIdentifier;
          woRequestParameters.isHHSRSHazard = null;
          woRequestParameters.hhsrsAssessment = undefined;
          try {
            await api.updateWorkOrderRepair(
              woRequestParameters,
              draftRepair.id,
              "eTag"
            );
          } catch (e) {
            console.error(e);
          }

          // get new WO data
          let workOrderDataResponse: any;
          try {
            workOrderDataResponse = await getWorkOrderById();
          } catch (e) {
            console.error(e);
          }

          dispatch(workOrderData(workOrderDataResponse));
          const priorityDraftRepair = draftRepair;
          priorityDraftRepair.priorityCode = draftRepairPriorityCode;
          dispatch(workOrderRepairObject(priorityDraftRepair));

          //fetch all data and redirect to repairDetails page
          //set all values for detail page

          //get eligibility
          const assetResponse = await (draftRepair.premisesId);
          if (assetResponse) {
            dispatch(assetByIdDataObject(assetResponse));
          }
          dispatch(
            userChosenSupplementaryQuestions(draftRepair.isSupplementary)
          );
          dispatch(userChosenVandalismQuestion(draftRepair.isVandalism));
          dispatch(userChosenCovidQuestion(draftRepair.isCovidSelfIsolated));
          if (draftRepair.isPotentialDuplicate) {
            dispatch(
              userChosenDuplicateQuestion("I don't think this is a duplicate")
            );
          }
          else {
            dispatch(userChosenDuplicateQuestion(''));
          }
          dispatch(
            userChosenSupplementaryQuestions(draftRepair.isSupplementary)
          );
          dispatch(
            userChosenVulnerabilityQuestion(
              draftRepair.isVulnerable ? "Yes" : "No"
            )
          );
          if (draftRepair.isVulnerable) {
            dispatch(
              userChosenVulnerabilityAdditionalInformation(
                draftRepair.VulnerableResponseText
              )
            );
          }
          else {
            dispatch(userChosenVulnerabilityAdditionalInformation(''));
          }
          dispatch(userChosenSOR(draftRepair.sorCode));
          dispatch(userChosenRepairLocation(draftRepair.repairLocation));
          dispatch(userChosenRepairLocationId(draftRepair.repairLocationId));

          dispatch(userChosenRelationDetails(draftRepair.reportedBy));
          dispatch(
            userChosenAdditionalDescription(draftRepair.additionalInformation)
          );

          customerResponse = customerDetails;
          dispatch(saveCustomerDetails(customerResponse));
          dispatch(
            saveCustomerphoneNumber(
              customerResponse?.addresses?.telecomsAddresses
            )
          );
          //dispatch(userChosenIsReporter(draftRepair?.reporterToBeContacted));
          dispatch(userChosenIsReporter(false));
          if (draftRepair?.reporterContactDetails != null) {
            const name = draftRepair.reporterContactDetails?.name?.givenName?.replaceAll(/\b(null|undefined)\b/g, "").trim() || "";
            dispatch(
              userChosenContactPhone(
                draftRepair.reporterContactDetails.contactNumber
              )
            );
            if (!userChosenContactNameVal) {
              dispatch(userChosenContactName(""));
            } else {
              dispatch(userChosenContactName(name));
            }
            dispatch(userChosenRelationDetails(draftRepair.reportedBy));
            dispatch(
              userChosenContactDetails(
                draftRepair.reporterContactDetails.contactNumber
              )
            );
          } else {
            dispatch(userChosenRelationDetails("Customer"));
            dispatch(userChosenContactPhone(""));
            dispatch(
              userChosenContactDetails(
                customerResponse?.addresses?.telecomsAddresses?.[0]?.number
              )
            );
          }

          dispatch(userChosenHighLevelDescription(draftRepair.repairReason));
          setIsLoading(false);
          dispatch(
            userChosenNotifyAll(
              draftRepair?.notifyAll === true
                ? "Yes"
                : draftRepair?.notifyAll === false
                  ? "No"
                  : null
            )
          );
          dispatch(userChosenEmergencyQuestion('No'));
          props.history.push("/ConfirmationDetails");
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getCustomerInfoForHeaderJourney = async (custId: string) => {
    try {
      const res = await api.getCustomer(custId);
      dispatch(customersData(res));
    } catch (e: any) {
      console.log("customer api failed")
    }
  }

  const resumeRepairHandler = async (draftRepair: any, isRedirectRequire: string = '') => {
    const preserveAssessmentDecisions = Boolean(draftRepair?.assessmentInformation?.identifier || draftRepair?.assessmentIdentifier);
    dispatch(resetHazardAssessmentData());
    dispatch(saveEmailCopyRadioValue(""));
    getCustomerInfoForHeaderJourney(draftRepair?.customerIdentifier);
    const customerIdentifier = customerID || draftRepair.customerIdentifier;
    dispatch(woFailureCase());
    dispatch(getPreviousPageName(isUndefinedNullOrEmpty(customerIdentifier) ? draftRepair.area : "customer"));
    let isEmailRedirect = (isRedirectRequire === "?reviewWorkOrder=true");
    let isResumeRedirectFromLanding = (isRedirectRequire === "?resumeWorkOrder=true");
    if (!isP360Maintainence) {
      // Calling tenancy api to get tenency group when user resume

      let supplementaryPremiseMessageCodes = "";
      if (draftRepair?.premisesId) {
        let tenancyGroup = "";
        if (customerIdentifier) {
          const responseTenancyGroup = await api.getTenanciesGroup(
            customerIdentifier,
            draftRepair.premisesId
          );
          tenancyGroup = responseTenancyGroup?.[0]?.tenancyGroup || "";
          dispatch(selectedTenancyGroup(tenancyGroup));
        }

        const premEligibilityResponse = await api.postPremisesEligibility(draftRepair.premisesId, tenancyGroup);
        supplementaryPremiseMessageCodes = premEligibilityResponse?.[0]?.supplimentaryCodes || "";
        dispatch(saveSupplimentaryCodes(supplementaryPremiseMessageCodes));

        // Override "Total loss of water" SOR code for communal properties to COMPUMP
        const draftRepairSorCode = preserveAssessmentDecisions ? draftRepair?.sorCode : getSorCode(draftRepair?.description, draftRepair?.sorCode, supplementaryPremiseMessageCodes);
        draftRepair.sorCode = draftRepairSorCode;
        draftRepair.originalWorkOrderSorCode = draftRepairSorCode;
      }

      dispatch(resumeDraftRepair(true));
      dispatch(isRepairMediaResume(true));
      let assetResponse = null;
      customerResponse = isNullOrUndefined(customerResponse) ? customerDetails : customerResponse;
      dispatch(saveCustomerDetails(customerResponse));
      dispatch(
        saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses)
      );
      dispatch(userChosenIsReporter(draftRepair?.reporterToBeContacted));
      if (
        draftRepair?.reporterContactDetails?.name?.givenName &&
        /^(?=.*\S)(?!null|undefined)\b\w+/i.test(draftRepair.reporterContactDetails.name.givenName)
      ) {
        const name = draftRepair.reporterContactDetails.name.givenName
          .replaceAll(/\b(null|undefined)\b/g, "")
          .trim();
        dispatch(userChosenContactPhone(draftRepair.reporterContactDetails.contactNumber));
        dispatch(userChosenContactName(name));

        dispatch(userChosenRelationDetails(draftRepair.reportedBy));
        dispatch(userChosenContactDetails(t("Provide_Number")))

        // draftRepair.reporterContactDetails.name = null;
      } else {

        dispatch(userChosenRelationDetails("Customer"));
        dispatch(userChosenContactPhone(""));
        dispatch(userChosenContactDetails(draftRepair?.reporterContactDetails?.contactNumber));

      }


      const {
        repairLocationId,
        repairLocation,
        repairReason,
        isSupplementary,
        isEmergency,
        additionalInformation,
        isVandalism,
        crimeReferenceNumber,
        isVulnerable,
        VulnerableResponseText,
        isCovidSelfIsolated,
        reporterContactDetails,
        originalWorkOrderSorCode,
        priority,
        area,
      } = draftRepair;

      const premiseType =
        area === "Block" || area === "Estate" || area === "Divided block"
          ? "Communal"
          : area;
      let responsedata: any;
      try {
        responsedata = await api.searchRepairReasons(
          repairReason,
          premiseType,
          identifiedCatalystProperty
        );
      } catch (e) {
        console.error(e);
      }
      const selectedReason = responsedata?.filter(
        (reason: any) => reason.description === repairReason
      );

      if (selectedReason?.length > 0 && selectedReason?.[0].sors.length > 0 && selectedReason?.[0].sors[0].sorCode) {
        selectedReason[0].sors[0].sorCode = getSorCode(selectedReason?.[0]?.description, selectedReason?.[0]?.sors?.[0]?.sorCode, supplementaryPremiseMessageCodes)
      }

      // Dispatching reason for AR1 role to popup Heating hot water dropdown
      dispatch(fetchRepairReasonsSelect(responsedata));
      // Calling tenancy api to get tenency group when user resume
      if (draftRepair?.premisesId && customerID) {
        const responseTenancyGroup = await api.getTenanciesGroup(
          customerID,
          draftRepair?.premisesId
        );
        dispatch(selectedTenancyGroup(responseTenancyGroup[0]?.tenancyGroup || ""));
      }
      dispatch(selectedRepairReasonObject(selectedReason));

      /*** This fetches the Updated Seasonal Priority for mapped Repair reasons from Drools ***/

      dispatch(selectedRepairReasonPriorityOverride(null));
      let customerPreferenceDataObj: Preference[] = [];
      customerPreferenceDataObj = customerResponse?.preferences?.concat(customerPreferenceDataObj);
      const isAnaTypeValue = customerPreferenceDataObj?.filter((additionalNeedAlert: any) =>
        additionalNeedAlert.preference.type === 'additionalNeeds').length > 0;

      let tenureCode = "";
      if (customerResponse?.tenanciesSummaries?.length > 1) {
        const tenancySummary = customerResponse?.tenanciesSummaries?.filter(
          (tenancy: any) =>
            tenancy?.tenancySummary?.tenancyEndDate === null
        );
        tenureCode = tenancySummary?.[0]?.tenancySummary?.tenancyTenureCode;
      }
      else {
        tenureCode = customerResponse?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode;
      }

      const raisedFormattedDate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");
      const resumedHazardAssessment = draftRepair?.hhsrsAssessment;
      const hasResumedHazardOutcome = Boolean(
        draftRepair?.assessmentInformation?.outcome &&
        resumedHazardAssessment?.category &&
        resumedHazardAssessment?.severity
      );
      const repairPriorityPayload: repairPriorityRequest = {
        isEmergency: draftRepair?.isEmergency === true,
        repairType: draftRepair?.sorCode,
        description: draftRepair?.description,
        channel: RepairChannel.ColleagueSelfServe,
        raisedDate: raisedFormattedDate,
        isAnaType: isAnaTypeValue,
        tenureCode: tenureCode,
        isV14Upgradable: selectedReason?.[0]?.isV14Upgradable, // to do when ED drafts are enabled for Resume repair
        workProgramme: selectedReason?.[0]?.sors?.[0]?.workProgramme,
        premisesType: premiseType,
        riskRating: hasResumedHazardOutcome ? resumedHazardAssessment?.severity : undefined,
        assessmentType: hasResumedHazardOutcome ? resumedHazardAssessment?.category : undefined,
        hasSeasonalPriority: selectedReason?.[0]?.hasSeasonalPriority ?? false
      };
      const contractorRepairPriority = preserveAssessmentDecisions ? draftRepair.priorityCode : (await api.repairPriorityDetermination(repairPriorityPayload))?.repairPriority;
      const repairPriority = preserveAssessmentDecisions ? draftRepair.priority : await getRepairPriority(contractorRepairPriority);

      dispatch(priorityCode(contractorRepairPriority));
      const repairReasonPriorityIsUpdated = repairPriority !== null && repairPriority !== draftRepair.priority;
      draftRepair.priority = repairReasonPriorityIsUpdated ? repairPriority : draftRepair.priority;
      if (!preserveAssessmentDecisions) {
        draftRepair.isEmergency = draftRepair.priority === "Emergency" || draftRepair.priority === "Emergency (OOH)" ? true : false;
      }
      dispatch(selectedRepairReasonPriorityOverride(draftRepair.priority));
      dispatch(selectedRepairReasonDefaultPriority(draftRepair.priority));
      dispatch(resumeRepairReasonPriorityUpdatedToEmergency(repairReasonPriorityIsUpdated && draftRepair.isEmergency));

      dispatch(workOrderRepairObject(draftRepair));


      // const area = props?.area != undefined ? props?.area : "";
      try {
        assetResponse = await fetchAssetData(draftRepair.premisesId);
        dispatch(assetByIdDataObject(assetResponse));
        errorData = removeAPIError(getAssetsById, errors);
        dispatch(storeAPIErrors(errorData))
      } catch (e) {
        console.error(e);
        errorData = addAPIError(getAssetsById, errors);
        dispatch(storeAPIErrors(errorData))
      }
      dispatch(selectedTenacyType(area));

      var maintsResp =
        assetResponse?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === "MAINTSRESP"
        )?.value ?? "";
      var repairResp =
        assetResponse?.maintenanceResponsibilities?.find(
          (resp: any) => resp.type === selectedReason?.[0]?.element
        )?.value ?? "";
      dispatch(getMaintResp(maintsResp));
      dispatch(getRepairResp(repairResp));

      if (
        selectedReason?.[0]?.additionalData &&
        selectedReason?.[0]?.additionalData?.length &&
        selectedReason?.[0]?.additionalData?.[0]?.description !== ""
      ) {
        const resumeData = {
          resumeHLRepair: selectedReason?.[0]?.description,
          resumeHLSubQuestion:
            selectedReason?.[0]?.additionalData?.[0]?.description,
          resumeSelectedProperty: area,
          resumePriority: priority,
        };
        dispatch(userResumeData(resumeData));
      } else {
        const resumeData = {
          resumeHLRepair: "",
          resumeHLSubQuestion: "",
          resumeSelectedProperty: area,
          resumePriority: priority,
        };
        dispatch(userResumeData(resumeData));
      }

      dispatch(userChosenSOR(originalWorkOrderSorCode));
      if (draftRepair.isPotentialDuplicate) {
        dispatch(
          userChosenDuplicateQuestion("I don't think this is a duplicate")
        );
      }
      repairLocation &&
        dispatch(userChosenRepairLocation(repairLocation)) &&
        dispatch(userChosenRepairLocationId(repairLocationId));
      repairReason && dispatch(userChosenHighLevelDescription(repairReason));
      isSupplementary === true
        ? dispatch(userChosenSupplementaryQuestions("Yes"))
        : isSupplementary === false
          ? dispatch(userChosenSupplementaryQuestions("No"))
          : dispatch(userChosenSupplementaryQuestions(""));
      isEmergency ?
        dispatch(
          userChosenEmergencyQuestion(t("Repair_Emergency_Radio1_Text"))
        )
        :
        dispatch(userChosenEmergencyQuestion("No"));
      additionalInformation &&
        dispatch(userChosenAdditionalDescription(t(additionalInformation))) &&
        dispatch(
          userChosenAdditionalDescriptionCOUNT(additionalInformation.length)
        );
      isVandalism
        ? dispatch(userChosenVandalismQuestion("Yes")) &&
        dispatch(
          userChosenVandalismAdditionalInformation(crimeReferenceNumber)
        )
        : dispatch(userChosenVandalismQuestion("No"));
      isVulnerable
        ? dispatch(userChosenVulnerabilityQuestion("Yes")) &&
        dispatch(
          userChosenVulnerabilityAdditionalInformation(VulnerableResponseText)
        )
        : dispatch(userChosenVulnerabilityQuestion("No"));
      isCovidSelfIsolated === true
        ? dispatch(userChosenCovidQuestion("Yes"))
        : isCovidSelfIsolated === false
          ? dispatch(userChosenCovidQuestion("No"))
          : dispatch(userChosenCovidQuestion(""));
      const resumeDraftDataCache = {
        repairLocation,
        repairLocationId,
        repairReason,
        repairSORCode: draftRepair?.sorCode,
        supplementaryQuestions:
          isSupplementary === true
            ? "Yes"
            : isSupplementary === false
              ? "No"
              : "",
        emergencyQuestion: isEmergency && t("Repair_Emergency_Radio1_Text"),
        additionalInformation,
        vandalismQuestion: isVandalism ? "Yes" : "No",
        crimeReferenceNumber: isVandalism ? crimeReferenceNumber : "",
        vulnerabilityQuestion: isVulnerable ? "Yes" : "No",

        vulnerableResponseText: isVulnerable ? VulnerableResponseText : "",
        covidQuestion:
          isCovidSelfIsolated === true
            ? "Yes"
            : isCovidSelfIsolated === false
              ? "No"
              : "",
        reporterContactDetails,
      };
      dispatch(userResumeDraftDataCache(resumeDraftDataCache));
      dispatch(
        userChosenNotifyAll(
          draftRepair?.notifyAll === true
            ? "Yes"
            : draftRepair?.notifyAll === false
              ? "No"
              : null
        )
      );
      // dispatching reason for AR1 role to popup Heating hot water dropdown
      dispatch(fetchRepairReasonsSelect(responsedata));

      // Need to add dispatcher for DMC to show the DMC page if wo response have case information data available
      if (draftRepair?.assessmentInformation?.supplementaryQuestionResponses ?? false) {
        // Reading supplementaryQuestionResponses and saving in store for future use
        const supplementaryResponsesObject: { [key: string]: any } = {};
        draftRepair?.assessmentInformation?.supplementaryQuestionResponses.forEach(
          (response: any) => {
            supplementaryResponsesObject[response.questionId] = Array.isArray(response.responseId) ? response.responseId : [response.responseId];
          }
        );
        dispatch(saveDMCAnswers(supplementaryResponsesObject));
      }

      // Storing DMCAssesment value for resume workorder
      if (draftRepair?.isRaisedAsTriage && draftRepair?.isSubmitted) {
        dispatch(WorkOrderCaseCreated(true));
      } else if (draftRepair?.isCausingDampAndMould) {
        if ((dmcInspectionSorCodes?.includes(draftRepair?.sorCode) || dmcRepairSorCodes?.includes(draftRepair?.sorCode))) {
          dispatch(dmcCheckSavedAnswer("No"));
        }
        else {
          dispatch(dmcCheckSavedAnswer("Yes"));
        }
      }
      else {
        dispatch(dmcCheckSavedAnswer(""));
      }
      // Assessing HHSRS value for resume wo
      const HHSRSAssessment = draftRepair?.hhsrsAssessment;
      const hasCompletedHazardAssessment = !isUndefinedNullOrEmpty(draftRepair?.hazardSorCode) && !isUndefinedNullOrEmpty(draftRepair?.assessmentInformation?.identifier);
      const setQuickWinsHHSRSAssessmentOptionYes = !isUndefinedNullOrEmpty(HHSRSAssessment?.category) || !isUndefinedNullOrEmpty(HHSRSAssessment?.severity);
      dispatch(saveHazardType(HHSRSAssessment?.category));
      dispatch(saveSaverityScore(HHSRSAssessment?.severity));
      dispatch(saveHHSRSOption(setQuickWinsHHSRSAssessmentOptionYes));
      dispatch(saveHHSRSAssessmentCompleted(hasCompletedHazardAssessment));
      // Adding redirect logic when resuming through email link
      if (!isEmailRedirect || isResumeRedirectFromLanding || (isEmailRedirect && ((duplicateOverridePermissions && choosePriorityPermission && draftRepair?.isPotentialDuplicate && draftRepair?.isVulnerable) ||
        (choosePriorityPermission && noTriagePermission && draftRepair?.isVulnerable && draftRepair?.sorCode === 'NA')
        || (duplicateOverridePermissions && noTriagePermission && draftRepair?.isPotentialDuplicate && draftRepair?.sorCode === 'NA')
        || (duplicateOverridePermissions && noTriagePermission && choosePriorityPermission && draftRepair?.isPotentialDuplicate && draftRepair?.isVulnerable && draftRepair?.sorCode === 'NA') ||
        (noTriagePermission && draftRepair?.sorCode === 'NA')
        || (duplicateOverridePermissions && draftRepair?.isPotentialDuplicate)
        || (choosePriorityPermission && draftRepair?.isVulnerable)
        || (choosePriorityPermission && isUnderReviewTriage)))
      ) {
        props.history.push('/RepairLocation');
      }

    }
    setIsLoading(false);
  };

  const getSorCode = (
    selectedReasonDescription: any,
    selectedReasonSorCode: any,
    supplimentaryCodes: any
  ): string => {
    const overrideTotalLossOfWaterCommSOR =
      selectedReasonDescription === "Total loss of water" &&
      supplimentaryCodes?.includes("FISPUMPS02");

    return overrideTotalLossOfWaterCommSOR
      ? "COMPUMP"
      : selectedReasonSorCode;
  };

  const getCancelRepairEligibility = async (
    workOrderResponse: CurrentRepair,
    assetTypeName: string | null | undefined
  ) => {
    const _customerId = localStorage.getItem("agent") || "";
    //get cancel repair eligibility
    const eligibleWorkProgramme = ["RESP", "RECALL", "GASRESP", "GASRECAL"];

    const checkAppointment: boolean =
      eligibleWorkProgramme.indexOf(
        workOrderResponse.workProgramme?.toUpperCase()
      ) > -1;
    if (workOrderResponse.isPendingAssessment && workOrderResponse.assessmentInformation && workOrderResponse?.sorCode === t("PRODAMP")) {
      setIsAppointment(false);
    }
    else {
      setIsAppointment(checkAppointment);
    }

    let assetType = workOrderResponse.area || assetTypeName || "";
    let assetTypeNameToUpdate = assetType;
    if (
      assetTypeNameToUpdate &&
      assetTypeNameToUpdate !== "" &&
      assetTypeNameToUpdate.toLowerCase() !== "property"
    ) {
      assetTypeNameToUpdate = "Communal";
    }

    const repairType =
      (workOrderResponse as any)?.repairType &&
        (workOrderResponse as any)?.repairType !== ""
        ? (workOrderResponse as any)?.repairType
        : "repair";

    const workProgramme = workOrderResponse.workProgramme;

    let eligibilityResponse: any;
    try {
      eligibilityResponse = await api.getCancelRepairEligibility(
        (workOrderResponse.reportingMethod = "ColleagueSelfService"),
        workOrderResponse.status,
        workOrderResponse.isDraft,
        workOrderResponse.isEmergency,
        workOrderResponse.isOutOfHours,
        workOrderResponse.isRecall ?? false,
        workOrderResponse.isEMA,
        workOrderResponse.isPotentialDuplicate,
        workOrderResponse.contractor,
        workOrderResponse.repairLocation,
        workOrderResponse.trade,
        workOrderResponse.sorCode,
        moment(new Date(workOrderResponse.raisedDate)).format("yyyy-MM-DD"),
        assetTypeNameToUpdate,
        workOrderResponse.appointmentStartDate,
        _customerId,
        workOrderResponse.customerIdentifier,
        repairType,
        workProgramme
      );
    } catch (e) {
      console.error(e);
    }
    setArea(assetType);
    setContractor(workOrderResponse.contractor);
    if (workOrderResponse.isPendingAssessment && workOrderResponse.assessmentInformation && workOrderResponse?.sorCode === t("PRODAMP")) {
      setIsCancelButton(false);
    }
    else if (eligibilityResponse?.isEligible) {
      setIsCancelButton(true);
      if (eligibilityResponse.errorCode === "") {
        setErrorCode("SSR036");
      } else {
        setErrorCode(eligibilityResponse.errorCode);
      }
    }
  };

  const viewWorkOrderHistory = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_work_order_history) !== -1;
  if (isLoading) {
    return (
      <div className="div-loader">
        <div className="SpinnerWrapper">
          <LoadingSpinner />
        </div>
      </div>
    );
  }
  const contractorSiteIdentifier = workOrders?.identifiers?.contractorSiteIdentifier

  const isUnknownEMADummyWorkOrder =
    contractorSiteIdentifier === EMAContractorType.UNKNOWN_EMA_TRIAGE ||
    contractorSiteIdentifier === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE || contractorSiteIdentifier === catalystTriageContractorType.CATALYST_TRIAGE_EMA;

  let displayJobNumber;

  if (workOrders?.identifiers?.jobNumber) {
    displayJobNumber = workOrders.identifiers.jobNumber;
  } else if (isUnknownEMADummyWorkOrder) {
    displayJobNumber = t("managing_agent_status");
  } else {
    displayJobNumber = jobNumber;
  }
  const isCreateRepairEligible = isRepairEnabled && isRaiseRepairEnabled && isAssetEligibleForRepair;
  const isResumeRepairEligible = (isRaiseRepairEnabled && ((workOrders?.statuses?.status === "In Diagnosis"
    && !isUnderReviewTriage) || (isUnderReviewTriage && reviewTriageRepairPermission) && !isUnknownEMADummyWorkOrder));
  const isSelectAppointmentEligible = isAppointmentRole && isAppointment && isContractorIntegerated
    && workOrders?.statuses?.status === "Unappointed" && (draftRepair?.priorityCode === RepairPriorityCode.NextAvailable
      || [RepairPriorityCode.DampAndMould, RepairPriorityCode.DampAndMouldLowRisk, RepairPriorityCode.DampAndMouldSignificant].includes(draftRepair?.priorityCode)
      || draftRepair?.priorityCode === RepairPriorityCode.V14 || draftRepair?.priorityCode === RepairPriorityCode.AWAABSLAWLOW || draftRepair?.priorityCode === RepairPriorityCode.AWAABSLAWSIGNIFICANT)
  const isCancleRepairEligible = isCancelButton === true && workOrders?.job?.repairType === WOTypes.repair;
  const isCancleSurveyEligible = isCancelButton && isCreateSurvey && workOrders?.job?.repairType === WOTypes.survey;
  const isKebabMenuVisible = isCreateRepairEligible || isResumeRepairEligible || isSelectAppointmentEligible
    || isRecallEligible || isCancleRepairEligible || isCancleSurveyEligible;

  return (
    <div className="border-t border-grey pb-12 bg-no-repeat bg-right-60% bg-50% md:bg-35% lg:bg-20% bg-fixed px-3">
      <div id="backmodal-div1" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0 global-txt flex space-between" >
        <div id="backmodal-p" className="text-teal text-xl mt-4 mb-4 sm-pl-1">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            data-testid="workOrderBackBtn"
            className="back-btn"
            onClick={backButtonHandler}
            onKeyDown={backButtonHandler}
          >
            <i className="fas fa-angle-left mr-2"></i>
            {t("back")}
          </a>
        </div>
        {isKebabMenuVisible && <div className="menu-nav ms-auto bd-highlight mt-3">
          <div className="dropdown-container-h btn-group">
            <div data-testid="dotsmenu"
              className="kebabBtn mr-1 btn btn-sm show three-dots-ast"
              data-bs-toggle="dropdown"
              onClick={dropDownFunction}
              onKeyDown={dropDownFunction}>
            </div>

            <div className=" dropdown-ast px-2 dropdown-menu show mt-45" style={{ display: dropDown }}>
              {isCreateRepairEligible ? (
                <a data-testid="callpage" className="text-base no-underline" onClick={callPageHandler} onKeyDown={callPageHandler}>
                  <div data-testid="create-repair" className={"py-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                    {assetValue === "Property" ? t("Create_repair") : t("raise_comm")}
                  </div>
                </a>

              ) : null}
              {isResumeRepairEligible ? (
                <a data-testid="resumeRepair" onClick={(e) => resumeRepairHandler(draftRepair)} onKeyDown={(e) => resumeRepairHandler(draftRepair)} className="text-black text-base no-underline global-txt">
                  <div className={"py-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>  {t("Resume_repair")}</div></a>
              ) : null}
              {isSelectAppointmentEligible ? (
                <a data-testid="selectAppointment" onClick={selectAppointmentHandler} onKeyDown={selectAppointmentHandler} className="text-black text-base no-underline">
                  <div className={"py-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>  {t("CP070")}</div></a>
              ) : null}

              {isRecallEligible ? (
                <a data-testid="recallRepair" onClick={recallRepairHandler} onKeyDown={recallRepairHandler} className="text-black text-base no-underline">
                  <div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item">  {t("CP107")}</div></a>
              ) : null}

              {isCancleRepairEligible ?
                <div className="global-txt dropdown-item" id="hisRepDet-con">
                  <div id="hisRepDet-main-btn" className="px-0 md:flex md:justify-between ">
                    <div>
                      <CancelModelRepair
                        id="repreason-exitmodal"
                        workOrderId={workOrders?.identifiers?.worksOrderIdentifier}
                        area={area}
                        errorCode={errorCode}
                        contractor={contractor}
                        props={props}
                      />
                    </div>
                  </div>
                </div> : null
              }
              {isCancleSurveyEligible ?
                <div className="global-txt dropdown-item" id="hisRepDet-con">
                  <div id="hisRepDet-main-btn" className="px-0 md:flex md:justify-between ">
                    <div>
                      <CancelModelSurvey
                        id="repreason-exitmodal"
                        workOrderId={workOrders?.identifiers?.worksOrderIdentifier}
                        area={area}
                        errorCode={errorCode}
                        contractor={contractor}
                        props={props}
                      />
                    </div>
                  </div>
                </div> : null
              }
            </div>
          </div>
        </div>
        }

      </div>
      <div className="container mx-auto">
        <div className="w-full global-txt g-4">

          <div className="flex flex-row d-flex bd-highlight">

            <div className="bd-highlight  ">
              {displayJobNumber && (
                <h1 className="mt-4 sm:mt-1 mpx-4">
                  {displayJobNumber} </h1>)}
              <p className="mt-2 global-txt">{t("CP076_Text")}</p>
            </div>

          </div>

          {identifiedCatalystProperty ? (
            <div className="warning-pre-line alert p-0">
              <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                <div className="px-4 pr-8">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6" aria-hidden="true">
                    <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
                </div>
                <div className="flex items-center">
                  <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                    <div>{catalystBannerMessageA}</div>
                    <br />
                    <div>{catalystBannerMessageB}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {(workOrders?.identifiers?.contractorSiteIdentifier === OnHoldContractor && !workOrders?.identifiers?.jobNumber) && <div className="warning-pre-line alert p-0">
            <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
              <div className="px-4 pr-8">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6" aria-hidden="true">
                  <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
              </div>
              <div className="flex items-center">
                <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                  <div>{t("responsive_repair")}</div>
                </div>
              </div>
            </div>
          </div>}

          {isSelectAppointmentChosen && woHadDemobilizedContractorSite && <div className="warning-pre-line alert p-0">
            <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
              <div className="px-4 pr-8">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6" aria-hidden="true">
                  <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
              </div>
              <div className="flex items-center">
                <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                  <div>{t("please_contact")} {workOrders.contractor.name} {t("on_phone")} {workOrders.contractor.phoneNumber} {t("book_appointment")}</div>
                </div>
              </div>
            </div>
          </div>
          }

          {workOrders?.asset?.isInDefect && workOrders?.identifiers?.jobNumber && workOrders.statuses.isVandalism && (
            <div className="warning-pre-line alert p-0">
              <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                <div className="px-4 pr-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor"
                    className="text-purple-100 w-6 h-6"
                    aria-hidden="true"
                  >
                    <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path>
                  </svg>
                </div>
                <div className="flex items-center">
                  <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                    <div>
                      {t("Vandalism_Message")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isCautionBanner ? (
            <div className="pb-2">
              <CautionAlert  {...props} />
            </div>
          ) : null
          }
          {
            (additionalNeedsAlertsBasic || additionalNeedsAlertsRestricted) ?
              (<div className="pb-2">
                <AdditionalNeedAlert  {...props} />
              </div>) : null

          }
          {isPropertyBanner && propertyCheck ? (
            <div className="pb-2">
              <PropertyAlert  {...props} />
            </div>
          ) : null
          }

          {isWorkCard && isWorkOrderLoaded ? (
            <div className="grid grid-cols-1 gap-4 md:gap-8 mt-2">
              <WorkOrderDetails id={workOrders?.identifiers?.worksOrderIdentifier} status={status} history={props.history} location={props.location} match={props.match} />
            </div>) : null}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">

            {isWorkCard && viewWorkOrderHistory ? (
              <div className="relative pb-16 border border-grey bg-white rounded-lg cust-card">
                <div>
                  <WorkOrderChronologySummary {...props} />
                </div>
              </div>
            ) : null}

            {isRepairFullyCreated && woSerialNumber ? (
              <div>
                <NotesCard
                  workOrderSerialNumber={woSerialNumber}
                  workOrderSequenceNumber={woSequenceNumber}
                  {...props}
                />
              </div>
            ) : null

            }

            {isAssetCard && (
              <div >
                <AssetCard errorFlag={errorFlag} {...props} />
              </div>
            )}



            {isCustomerCard && (workOrders?.asset?.type?.assetTypeName === 'Property' || assetValue === 'Property') ? (
              <WorkOrderCustomerCard customerId={customerIdentifier} propertyId={workOrders.identifiers?.asset?.assetIdentifier} uprn={assetUprn} workOrderId={workOrders.identifiers?.worksOrderIdentifier} assetType={workOrders.asset?.type?.assetTypeName ? workOrders.asset?.type?.assetTypeName : assetValue} {...props} />
            ) : null
            }

          </div>

          <div>
            {(backToTop && width <= 820) && <BackToTopComponent />}
          </div>
        </div>

      </div>
    </div>
  );
};
export default WorkOrder360View;
